import React from "react"
import ReadLearnLandingPageLayout from "./ReadLearnLandingPageLayout"
import { FullScreenLoading } from "./shared/FullScreenLoading"
import useGetCategories from "./shared/useGetCategories"
import { ErrorPage } from "../views/app/ErrorPage"
import { PageLayout } from "#/features/global-ui/page-layout"

export default function ReadLearnLandingPage(): JSX.Element {
  const { data: categories, isLoading, isError } = useGetCategories()

  if (isError) {
    return (
      <PageLayout>
        <ErrorPage />
      </PageLayout>
    )
  }
  return isLoading ? <FullScreenLoading /> : <ReadLearnLandingPageLayout categories={categories} />
}
